import { render, staticRenderFns } from "./NewVideo.vue?vue&type=template&id=6bcdcd0e&scoped=true&"
import script from "./NewVideo.vue?vue&type=script&lang=js&"
export * from "./NewVideo.vue?vue&type=script&lang=js&"
import style0 from "./NewVideo.vue?vue&type=style&index=0&id=6bcdcd0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcdcd0e",
  null
  
)

export default component.exports